export default data => {
  return {
    '@type': 'ContactPage',
    name: data?.title,
    description: data?.description,
    inLanguage: 'English',
    url: data?.canonicalUrl,
  };
};
